import { render, staticRenderFns } from "./BloggerButton.vue?vue&type=template&id=33d5a64c&scoped=true&"
import script from "./BloggerButton.vue?vue&type=script&lang=js&"
export * from "./BloggerButton.vue?vue&type=script&lang=js&"
import style0 from "./BloggerButton.vue?vue&type=style&index=0&id=33d5a64c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d5a64c",
  null
  
)

export default component.exports